// // ============================================
// // src/components/home/HeroMainContent.tsx
// // ============================================
// "use client";
// import { Box, Typography, Grid } from '@mui/material';
// import HeroBadge from '../home/HeroBadge';
// import HeroButtons from '../home/HeroButtons';
// import HeroCarousel from '../home/HeroCarousel';
// import { heroStats, heroContent } from '@/data/heroData';

// interface HeroMainContentProps {
//   isVisible: boolean;
// }

// export default function HeroMainContent({ isVisible }: HeroMainContentProps) {
//   return (
//     <Grid container spacing={6} alignItems="center" sx={{ mb: { xs: 8, md: 12 } }}>
//       {/* Texto */}
//       <Grid size={{ xs: 12, md: 6 }} sx={{
//         pl: { md: 4, lg: 6, xl: 8 }
//       }}>
//         <Box
//           sx={{
//             opacity: isVisible ? 1 : 0,
//             transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
//             transition: 'all 1s cubic-bezier(0.4, 0, 0.2, 1)',
//           }}
//         >
//           <HeroBadge text={heroContent.badgeText} />

//           <Typography
//             component="h1"
//             variant="h1"
//             sx={{
//               color: 'white',
//               fontWeight: 900,
//               fontSize: { xs: '2.5rem', sm: '3rem', md: '3.5rem', lg: '4rem' },
//               lineHeight: 1.2,
//               mb: 3,
//               textShadow: '0 4px 20px rgba(0, 0, 0, 0.5)',
//             }}
//           >
//             {heroContent.title.split(' en ')[0]} en{' '}
//             <Box
//               component="span"
//               sx={{
//                 display: 'block',
//                 background: 'linear-gradient(90deg, #60a5fa 0%, #93c5fd 100%)',
//                 backgroundClip: 'text',
//                 WebkitBackgroundClip: 'text',
//                 WebkitTextFillColor: 'transparent',
//                 textShadow: 'none',
//               }}
//             >
//               {heroContent.title.split(' en ')[1]}
//             </Box>
//           </Typography>

//           <Typography
//             variant="h6"
//             sx={{
//               color: 'rgba(255, 255, 255, 0.9)',
//               mb: 4,
//               lineHeight: 1.7,
//               fontWeight: 400,
//               maxWidth: '90%',
//             }}
//           >
//             {heroContent.description}
//           </Typography>

//           <HeroButtons />

//           {/* Estadísticas */}
//           <Box
//             sx={{
//               display: 'flex',
//               gap: 2,
//               mt: 6,
//               flexWrap: 'wrap',
//             }}
//           >
//             {heroStats.map((stat, index) => {
//               const IconComponent = stat.icon;
//               return (
//                 <Box
//                   key={index}
//                   sx={{
//                     opacity: isVisible ? 1 : 0,
//                     transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
//                     transition: `all 0.8s cubic-bezier(0.4, 0, 0.2, 1) ${0.4 + index * 0.15}s`,
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: 1.25,
//                     border: '1px solid rgba(255, 255, 255, 0.1)',
//                     borderRadius: 2,
//                     p: 1.5,
//                     minWidth: 'fit-content',
//                     flex: '1 1 auto',
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       background: `${stat.color}25`,
//                       borderRadius: '50%',
//                       p: 1,
//                       width: 36,
//                       height: 36,
//                     }}
//                   >
//                     <IconComponent sx={{ 
//                       fontSize: 20, 
//                       color: stat.color === '#3b82f6' ? '#60a5fa' : 
//                              stat.color === '#f59e0b' ? '#fbbf24' : 
//                              stat.color === '#059669' ? '#10b981' : '#ec4899'
//                     }} />
//                   </Box>
//                   <Box>
//                     <Typography
//                       variant="h6"
//                       sx={{
//                         color: 'white',
//                         fontWeight: 700,
//                         lineHeight: 1.1,
//                         fontSize: '1.1rem',
//                         mb: 0.25,
//                       }}
//                     >
//                       {stat.value}
//                     </Typography>
//                     <Typography
//                       variant="caption"
//                       sx={{
//                         color: 'rgba(255, 255, 255, 0.7)',
//                         fontSize: '0.7rem',
//                         fontWeight: 500,
//                         lineHeight: 1.2,
//                         display: 'block',
//                       }}
//                     >
//                       {stat.label}
//                     </Typography>
//                   </Box>
//                 </Box>
//               );
//             })}
//           </Box>
//         </Box>
//       </Grid>

//       {/* Carrusel */}
//       <Grid size={{ xs: 12, md: 6 }} sx={{
//         display: 'flex',
//         justifyContent: 'flex-end',
//         pr: { md: 4, lg: 8, xl: 16 }
//       }}>
//         <Box
//           sx={{
//             opacity: isVisible ? 1 : 0,
//             transform: isVisible ? 'translateX(0)' : 'translateX(50px)',
//             transition: 'all 1s cubic-bezier(0.4, 0, 0.2, 1) 0.3s',
//             display: { xs: 'none', md: 'block' },
//             width: '100%',
//             maxWidth: 600,
//             ml: 'auto',
//           }}
//         >
//           <HeroCarousel />
//         </Box>
//       </Grid>
//     </Grid>
//   );
// }







// ============================================
// src/components/home/HeroMainContent.tsx - VERSIÓN SIMPLIFICADA
// ============================================
"use client";
import { memo, useMemo } from 'react';
import { Box, Typography, Grid } from '@mui/material';
import HeroBadge from '../home/HeroBadge';
import HeroButtons from '../home/HeroButtons';
import HeroCarousel from '../home/HeroCarousel';
import { heroStats, heroContent } from '@/data/heroData';

interface HeroMainContentProps {
  isVisible: boolean;
}

// Componente memoizado para cada estadística - SIMPLIFICADO
const StatItem = memo(({ 
  stat, 
  index, 
  isVisible 
}: { 
  stat: typeof heroStats[number]; 
  index: number; 
  isVisible: boolean;
}) => {
  const IconComponent = stat.icon;
  
  return (
    <Box
      sx={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
        transition: `all 0.8s cubic-bezier(0.4, 0, 0.2, 1) ${0.4 + index * 0.15}s`,
        display: 'flex',
        alignItems: 'center',
        gap: 1.25,
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: 2,
        p: 1.5,
        minWidth: 'fit-content',
        flex: '1 1 auto',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: `${stat.color}25`,
          borderRadius: '50%',
          p: 1,
          width: 36,
          height: 36,
        }}
      >
        <IconComponent sx={{ 
          fontSize: 20, 
          color: stat.color 
        }} />
      </Box>
      <Box>
        <Typography
          variant="h6"
          sx={{
            color: 'white',
            fontWeight: 700,
            lineHeight: 1.1,
            fontSize: '1.1rem',
            mb: 0.25,
          }}
        >
          {stat.value}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: '0.7rem',
            fontWeight: 500,
            lineHeight: 1.2,
            display: 'block',
          }}
        >
          {stat.label}
        </Typography>
      </Box>
    </Box>
  );
});

StatItem.displayName = 'StatItem';

const HeroMainContent = memo(({ isVisible }: HeroMainContentProps) => {
  const [titlePart1, titlePart2] = useMemo(() => 
    heroContent.title.split(' en '), 
  []);

  const animationStyle = useMemo(() => ({
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
    transition: 'all 1s cubic-bezier(0.4, 0, 0.2, 1)',
  }), [isVisible]);

  return (
    <Grid container spacing={6} alignItems="center" sx={{ mb: { xs: 8, md: 12 } }}>
      {/* Texto */}
      <Grid size={{ xs: 12, md: 6 }} sx={{ pl: { md: 4, lg: 6, xl: 8 } }}>
        <Box sx={animationStyle}>
          <HeroBadge text={heroContent.badgeText} />

          <Typography 
            component="h1" 
            variant="h1"
            sx={{
              color: 'white',
              fontWeight: 900,
              fontSize: { xs: '2.5rem', sm: '3rem', md: '3.5rem', lg: '4rem' },
              lineHeight: 1.2,
              mb: 3,
              textShadow: '0 4px 20px rgba(0, 0, 0, 0.5)',
            }}
          >
            {titlePart1} en{' '}
            <Box
              component="span"
              sx={{
                display: 'block',
                background: 'linear-gradient(90deg, #60a5fa 0%, #93c5fd 100%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                textShadow: 'none',
              }}
            >
              {titlePart2}
            </Box>
          </Typography>

          <Typography
            variant="h6"
            sx={{
              color: 'rgba(255, 255, 255, 0.9)',
              mb: 4,
              lineHeight: 1.7,
              fontWeight: 400,
              maxWidth: '90%',
            }}
          >
            {heroContent.description}
          </Typography>

          <HeroButtons />

          {/* Estadísticas */}
          <Box sx={{ display: 'flex', gap: 2, mt: 6, flexWrap: 'wrap' }}>
            {heroStats.map((stat, index) => (
              <StatItem 
                key={stat.label}
                stat={stat} 
                index={index} 
                isVisible={isVisible} 
              />
            ))}
          </Box>
        </Box>
      </Grid>

      {/* Carrusel */}
      <Grid size={{ xs: 12, md: 6 }} sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        pr: { md: 4, lg: 8, xl: 16 }
      }}>
        <Box
          sx={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateX(0)' : 'translateX(50px)',
            transition: 'all 1s cubic-bezier(0.4, 0, 0.2, 1) 0.3s',
            display: { xs: 'none', md: 'block' },
            width: '100%',
            maxWidth: 600,
            ml: 'auto',
          }}
        >
          <HeroCarousel />
        </Box>
      </Grid>
    </Grid>
  );
});

HeroMainContent.displayName = 'HeroMainContent';

export default HeroMainContent;